import {
  createContext,
  useContext,
  useState,
  useCallback,
  type ReactNode,
} from 'react';

interface CreateAbsenceRequestDialogContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  openDialog: () => void;
}

const CreateAbsenceRequestDialogContext =
  createContext<CreateAbsenceRequestDialogContextValue | null>(null);

export function useCreateAbsenceRequestDialog() {
  const context = useContext(CreateAbsenceRequestDialogContext);
  if (!context) {
    throw new Error(
      'useCreateAbsenceRequestDialog must be used within CreateAbsenceRequestDialogProvider',
    );
  }
  return context;
}

interface CreateAbsenceRequestDialogProviderProps {
  children: ReactNode;
}

export function CreateAbsenceRequestDialogProvider({
  children,
}: CreateAbsenceRequestDialogProviderProps) {
  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);

  return (
    <CreateAbsenceRequestDialogContext.Provider
      value={{ open, setOpen, openDialog }}
    >
      {children}
    </CreateAbsenceRequestDialogContext.Provider>
  );
}
